/**
 * English - Navigation translations
 */
export const nav = {
  home: 'Home',
  dashboard: 'Dashboard',
  applications: 'Applications',
  documents: 'Documents',
  profile: 'Profile',
  settings: 'Settings',
  help: 'Help',
  logout: 'Logout',
  login: 'Login',
  register: 'Register',
  features: 'Features',
  pricing: 'Pricing',
  about: 'About',
  contact: 'Contact',
  blog: 'Blog',
  faq: 'FAQ',
  security: 'Security',
  appraisers: 'Appraisers',
  simulator: 'Simulator',
  coApplicantPortal: 'My co-applicant portal',
} as const;